import { ChevronLeftIcon, PaperClipIcon } from "@heroicons/react/solid";
import { Link } from "gatsby";
import React from "react";
import CompanyCard from "../components/company-card/company-card";
import Layout from "../components/layout/layout";

export default function CompanyProfile({ pageContext, location }) {
  const { node } = pageContext;

  return (
    <Layout>
      {/** HEADING */}
      <div className="grid grid-cols-3">
        <Link to="/" className="inline-flex items-center">
          <ChevronLeftIcon
            className="-ml-0.5 mr-1 h-4 w-4"
            aria-hidden="true"
          />
          <span className="ml-1 text-sm font-medium text-gray-500 hover:text-gray-700">
            Retour aux résultats
          </span>
        </Link>

        <div className="mt-2 md:flex md:items-center md:justify-between">
          <div className="flex-1 min-w-0">
            <h2 className="text-2xl font-bold leading-7 text-qe-light-blue sm:text-3xl sm:truncate text-center">
              {node.name}
            </h2>
          </div>
        </div>
        <span></span>
      </div>

      <CompanyCard company={node} withPadding />
    </Layout>
  );
}
